module.exports = __webpack_public_path__ + "media/images/linkPlaceholder-cd404a70.png";